/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApplicationUserFromJSON, ApplicationUserToJSON, CarFromJSON, CarToJSON, CarEquipmentFromJSON, CarEquipmentToJSON, GarageFromJSON, GarageToJSON, GarageSpotAttributeFromJSON, GarageSpotAttributeToJSON, } from './';
export function GarageSpotFromJSON(json) {
    return GarageSpotFromJSONTyped(json, false);
}
export function GarageSpotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (json['modifiedDate'] === null ? null : new Date(json['modifiedDate'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : ApplicationUserFromJSON(json['createdBy']),
        'createdById': !exists(json, 'createdById') ? undefined : json['createdById'],
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : ApplicationUserFromJSON(json['modifiedBy']),
        'modifiedById': !exists(json, 'modifiedById') ? undefined : json['modifiedById'],
        'carId': !exists(json, 'carId') ? undefined : json['carId'],
        'car': !exists(json, 'car') ? undefined : CarFromJSON(json['car']),
        'garageId': !exists(json, 'garageId') ? undefined : json['garageId'],
        'garage': !exists(json, 'garage') ? undefined : GarageFromJSON(json['garage']),
        'carEquipments': !exists(json, 'carEquipments') ? undefined : (json['carEquipments'] === null ? null : json['carEquipments'].map(CarEquipmentFromJSON)),
        'attributes': !exists(json, 'attributes') ? undefined : (json['attributes'] === null ? null : json['attributes'].map(GarageSpotAttributeFromJSON)),
    };
}
export function GarageSpotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'createdBy': ApplicationUserToJSON(value.createdBy),
        'modifiedBy': ApplicationUserToJSON(value.modifiedBy),
        'carId': value.carId,
        'car': CarToJSON(value.car),
        'garageId': value.garageId,
        'garage': GarageToJSON(value.garage),
        'carEquipments': value.carEquipments === undefined ? undefined : (value.carEquipments === null ? null : value.carEquipments.map(CarEquipmentToJSON)),
        'attributes': value.attributes === undefined ? undefined : (value.attributes === null ? null : value.attributes.map(GarageSpotAttributeToJSON)),
    };
}
